import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
}), 'FormatStrikethrough');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatStrikethrough.js
// module id = 3894
// module chunks = 2